var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "member-form tongxin-layout"
  }, [_c('h1', {
    staticClass: "title-with-underline"
  }, [_vm._v(" 請輸入掛號對象資料 ")]), _c('form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("身分證字號")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formData.idno,
      expression: "formData.idno"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "請輸入身分證字號",
      "maxlength": "10",
      "required": ""
    },
    domProps: {
      "value": _vm.formData.idno
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "idno", $event.target.value);
      }
    }
  }), _vm.errors.idno ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.idno))]) : _vm._e()]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("出生年月日")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formData.birthday,
      expression: "formData.birthday"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "required": ""
    },
    domProps: {
      "value": _vm.formData.birthday
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "birthday", $event.target.value);
      }
    }
  }), _vm.errors.birthday ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.birthday))]) : _vm._e()])]), _vm.hasSearched ? _c('div', {
    staticClass: "search-result"
  }, [_c('h2', {
    staticClass: "result-title"
  }, [_vm._v("查詢結果")]), _vm.reservations.length > 0 ? _c('div', {
    staticClass: "appointment-list"
  }, _vm._l(_vm.reservations, function (reservation, index) {
    return _c('ReservationCard', {
      key: reservation.reservationId,
      attrs: {
        "reservation": reservation,
        "isExpanded": _vm.expandedCards[index],
        "isSelected": false
      },
      on: {
        "click": function click($event) {
          return _vm.toggleCard(reservation, index);
        }
      }
    });
  }), 1) : _c('div', {
    staticClass: "empty-state"
  }, [_c('div', {
    staticClass: "empty-icon"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 6v6l4 2"
    }
  })])]), _c('p', {
    staticClass: "empty-text"
  }, [_vm._v("查無預約紀錄")])])]) : _vm._e(), _c('div', {
    staticStyle: {
      "margin-bottom": "96px"
    }
  }), _c('div', {
    staticClass: "fixed-footer-navigation"
  }, [_c('TongxinNavigation', {
    attrs: {
      "canProceed": !_vm.isLoading,
      "backButtonIsVisible": true,
      "nextButtonIsVisible": true,
      "textForNextStep": '送出查詢'
    },
    on: {
      "back": _vm.goBack,
      "next": _vm.handleSubmit
    }
  })], 1), _vm.isLoading ? _c('div', {
    staticClass: "loading-overlay"
  }, [_c('b-spinner', {
    staticStyle: {
      "border-width": "2px"
    }
  })], 1) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }